var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    height: "100%",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st1{fill:#ACACAC;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M875,546.9v70.3c0,16-11.6,34.8-25.9,41.9L828,669.6c-2.9,88-75.2,158.5-164,158.5h-35.2   c-19.4,0-35.2-15.7-35.2-35.2V535.2c0-19.4,15.7-35.2,35.2-35.2h35.2c45.9,0,87.4,18.9,117.2,49.3v-2.4   c0-155.1-126.2-281.2-281.2-281.2c-155.1,0-281.2,126.2-281.2,281.2v2.4C248.5,518.9,290,500,335.9,500h35.2   c19.4,0,35.2,15.7,35.2,35.2V793c0,19.4-15.7,35.2-35.2,35.2h-35.2c-88.7,0-161-70.5-164-158.5l-21.1-10.5   c-14.3-7.2-25.9-25.9-25.9-41.9v-70.3c0-207.3,167.8-375,375-375C707.3,171.9,875,339.6,875,546.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListen);
export default __webpack_public_path__ + "static/media/listen.e52a17f3f999f0df26da4ba09625dc51.svg";
export { ForwardRef as ReactComponent };